import Image from 'next/image';

import { useLightBoxModal } from '@screens/Product/hooks/useLightBoxModal';
import { ID_CLIENTS_PHOTO_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { HoverMask } from '@shared/ui/HoverMask/HoverMask';
import { LightBoxModal } from '@widgets/LightBoxModal';

import { Caption } from '../Caption/Caption';
import { EmptyState } from '../EmptyState/EmptyState';
import cls from './Photo.module.scss';

export const Photo = () => {
  const props = useAppSelector((state) => state.product.data.props);
  const photos = props[ID_CLIENTS_PHOTO_ATTRIBUTE]?.values || [];

  const { openLightBoxModal, currentImgUrl, imageUrls, handleCloseLightBox, handleChangeCurrentImageUrl } =
    useLightBoxModal({ values: photos, mobileOn: true });

  if (!imageUrls?.length) {
    return <EmptyState />;
  }

  return (
    <div className={cls.wrap}>
      <Caption>Фото</Caption>
      <div className={cls.grid}>
        {imageUrls.map((photo, index) => (
          <div
            key={photo}
            className={cls.photo}
            onClick={handleChangeCurrentImageUrl(photo)}
          >
            <HoverMask mobileHidden />
            <Image
              src={photo}
              alt={`фото ${index}`}
              fill
            />
          </div>
        ))}
      </div>

      {currentImgUrl && openLightBoxModal && (
        <LightBoxModal
          open={openLightBoxModal}
          onClose={handleCloseLightBox}
          currentImageUrl={currentImgUrl}
          imageUrls={imageUrls}
        />
      )}
    </div>
  );
};
